/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Pondělí`
};

const da_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Mandag`
};

const de_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Montag`
};

const en_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Monday`
};

const es_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Lunes`
};

const fr_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Lundi`
};

const hu_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Hétfő`
};

const it_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Lunedì`
};

const nl_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Maandag`
};

const pl_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Poniedziałek`
};

const pt_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Segunda-feira`
};

const sv_weekdays_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Måndag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const weekdays_monday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.weekdays_monday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("weekdays_monday", locale)
	if (locale === "cs") return cs_weekdays_monday(inputs)
	if (locale === "da") return da_weekdays_monday(inputs)
	if (locale === "de") return de_weekdays_monday(inputs)
	if (locale === "en") return en_weekdays_monday(inputs)
	if (locale === "es") return es_weekdays_monday(inputs)
	if (locale === "fr") return fr_weekdays_monday(inputs)
	if (locale === "hu") return hu_weekdays_monday(inputs)
	if (locale === "it") return it_weekdays_monday(inputs)
	if (locale === "nl") return nl_weekdays_monday(inputs)
	if (locale === "pl") return pl_weekdays_monday(inputs)
	if (locale === "pt") return pt_weekdays_monday(inputs)
	return sv_weekdays_monday(inputs)
};
export { weekdays_monday as "weekdays.monday" }